<p class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</p>

<form class="kt-form" [formGroup]="moduleForm" *ngIf="moduleForm" autocomplete="off" >
  <h2 class="page-titel">Fraud Module</h2>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>Module Name</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="name"
          class="form-control"
          placeholder="Enter Module Name"
          style="width: 100%;"
        />
      </div>
      <div class="alert alert-danger" *ngIf="formValidator.formErrors.name">
        {{ formValidator.formErrors.name }}
      </div>
    </div>
    <div class="form-group col-lg-4">
      <label>Provider</label>
      <div class="input-group" style="width: 100%;">
        <select
          style="border: 1px #cccccc solid; padding: 0.5rem"
          formControlName="provider"
          class="form-control"
        >
        <option disabled value="null" selected>Choose Provider</option>

          <option
            *ngFor="let provider of providers"
            [value]="provider.id"
            >{{ provider.name }}
          </option>
        </select>
      </div>
      <div class="alert alert-danger" *ngIf="formValidator.formErrors.provider">
        {{ formValidator.formErrors.provider }}
      </div>
    </div>
    <div class="form-group col-lg-4">
      <div class="input-group checkbox-label" style="margin-top: 2rem;margin-left: 2 rem;">
        <mat-checkbox
          formControlName="active"
          >Set Active!</mat-checkbox>
      </div>
    </div>
  </div>
</form>
<button [disabled]="formsValidation" class="btn btn-primary" (click)="save()" >Save Fraud Module</button>
